import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../mobile.css';

const PersonRow = ({ label, person }) => {
  if (!person) return null;
  return (
    <div style={{ marginBottom: '8px' }}>
      <span style={{ fontWeight: 700 }}>{label}: </span>
      <span>{person.name || '-'}{person.age ? `, Age ${person.age}` : ''}{person.gender ? `, ${person.gender}` : ''}</span>
    </div>
  );
};

const MobileCaseDetails = () => {
  const location = useLocation();
  const fir = location.state?.fir;
  const [showComplaint, setShowComplaint] = useState(false);

  if (!fir) {
    return <p style={{ textAlign: 'center', fontWeight: 700 }}>No case details available.</p>;
  }

  const sections = Array.isArray(fir.firSections)
    ? fir.firSections.map((s) => `${s.number} ${s.act}`).join(', ')
    : '-';

  return (
    <div>
      <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '15px', color: '#094268' }}>Case Details</h2>

      <div style={{ marginBottom: '8px' }}><span style={{ fontWeight: 700 }}>Case Type: </span>{fir.caseType || 'Matrimonial'}</div>
      <div style={{ marginBottom: '8px' }}><span style={{ fontWeight: 700 }}>Sections: </span>{sections}</div>

      <PersonRow label="Complainant" person={fir.complainant} />
      <PersonRow label="Victim" person={fir.victim} />

      {Array.isArray(fir.accusedList) && fir.accusedList.length > 0 && (
        <div style={{ marginBottom: '8px' }}>
          <span style={{ fontWeight: 700 }}>Accused: </span>
          {fir.accusedList.map((a) => `${a.name || '-'}${a.age ? `, ${a.age}` : ''}${a.gender ? `, ${a.gender}` : ''}`).join('; ')}
        </div>
      )}

      {fir.firText && (
        <div style={{ marginTop: '16px' }}>
          <button
            onClick={() => setShowComplaint(!showComplaint)}
            className="m-pill-btn"
            style={{ color: '#094268', fontWeight: 600 }}
          >
            {showComplaint ? 'Hide Complaint' : 'Show Complaint'}
          </button>
          {showComplaint && (
            <p style={{ marginTop: '10px', textAlign: 'justify', whiteSpace: 'pre-wrap' }}>{fir.firText}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default MobileCaseDetails;
